import { BaseService } from '../../infra/base.service'
import type { UpsertStatisticDto } from './dto/upsert-statistic.dto'
import type { Statistic } from './statistic'
import type { StatisticsRepository } from './statistics.repository'

export class StatisticsService extends BaseService<Statistic> {
    // chaves já tickadas nesta carga do app — window.api é instanciado uma vez por sessão (ver init.ts),
    // então este Set vive exatamente pelo tempo de uma "sessão" no sentido usado pelas chaves nav.*
    private tickedOnce = new Set<string>()

    constructor(private rep: StatisticsRepository) {
        super(rep)
    }

    async tick(key: string) {
        try {
            return await this.rep.tick(key)
        } catch (error) {
            return null
        }
    }

    // dispara tick no máximo uma vez por sessão para a mesma key. Uso: eventos de presença
    // ("essa sessão usou o módulo X"), onde o que importa é se aconteceu, não quantas vezes.
    tickOnce(key: string) {
        if (this.tickedOnce.has(key)) return
        this.tickedOnce.add(key)
        this.tick(key) // sem await propositalmente, mesmo padrão do app.load em init.ts
    }

    // Páginas públicas (/public/*): não há sessão, então o companyId vem do próprio contexto da página
    // (querystring, link de pagamento, formulário). Só aceita chaves `pub.*` — ver a allowlist no backend.
    // Silencioso por definição: telemetria não pode atrapalhar quem está respondendo NPS ou pagando.
    async tickPublic(companyId: string, key: string) {
        try {
            if (!companyId) return null
            return await this.rep.tickPublic(companyId, key)
        } catch (error) {
            return null
        }
    }

    // versão 1x-por-sessão do tickPublic, para os eventos de "abriu a página"
    tickPublicOnce(companyId: string, key: string) {
        if (!companyId) return
        const dedupeKey = companyId + '|' + key
        if (this.tickedOnce.has(dedupeKey)) return
        this.tickedOnce.add(dedupeKey)
        this.tickPublic(companyId, key)
    }

    async upsert(dto: UpsertStatisticDto) {
        return await this.rep.upsert(dto)
    }
}
